import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute, Link } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";
import { Button } from "@roqua/components/ui/button";

import { PageTitle } from "@/components/PageTitle";
import { ProtocolSubscriptionList } from "@/features/ProtocolSubscriptions/ProtocolSubscriptionList";
import { AutoProtocolsQuery } from "@/features/ProtocolSubscriptions/queries";
import { useTranslation } from "@/i18n/client";
import { useSessionContext } from "@/session";

export const Route = createFileRoute("/$organizationKey/$dossierId/protocol_subscriptions/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("ProtocolSubscriptions");
  const { organizationKey, dossierId } = useSessionContext();
  const { data } = useSuspenseQuery(AutoProtocolsQuery, {
    variables: { organizationKey, dossierId },
  });

  const activeSubscriptions = data.dossier.activeProtocolSubscriptions.nodes;
  const stoppedSubscriptions = data.dossier.stoppedProtocolSubscriptions.nodes;
  const stoppedSubscriptionsCount = data.dossier.stoppedProtocolSubscriptions.totalCount;

  return (
    <>
      <PageTitle title="protocolSubscriptions" />
      <Section variant="header">
        <SectionHeader header={t("activeProtocolSubscriptions")} />

        {activeSubscriptions.length > 0 && (
          <ProtocolSubscriptionList protocolSubscriptions={activeSubscriptions} />
        )}
      </Section>

      {stoppedSubscriptions.length > 0 && (
        <Section variant="content">
          <SectionHeader header={t("stoppedSubscriptions")} />

          <ProtocolSubscriptionList protocolSubscriptions={stoppedSubscriptions} />

          {stoppedSubscriptionsCount > 4 && (
            <div className="text-center">
              <Link
                to="/$organizationKey/$dossierId/protocol_subscriptions/stopped"
                params={{ organizationKey, dossierId }}
              >
                <Button>{t("olderProtocolSubscriptions")}</Button>
              </Link>
            </div>
          )}
        </Section>
      )}
    </>
  );
}
